module.exports = __webpack_public_path__ + "img/file_field_icon.a43bd8e4.svg";